import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ba32fa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "WorkplaceItemsFilters__header" }
const _hoisted_2 = { class: "flex items-center gap-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "mr-2",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15.8346 4.16699H15.0013V2.50033C15.0013 2.27931 14.9135 2.06735 14.7572 1.91107C14.6009 1.75479 14.389 1.66699 14.168 1.66699C13.947 1.66699 13.735 1.75479 13.5787 1.91107C13.4224 2.06735 13.3346 2.27931 13.3346 2.50033V4.16699H6.66797V2.50033C6.66797 2.27931 6.58017 2.06735 6.42389 1.91107C6.26761 1.75479 6.05565 1.66699 5.83464 1.66699C5.61362 1.66699 5.40166 1.75479 5.24538 1.91107C5.0891 2.06735 5.0013 2.27931 5.0013 2.50033V4.16699H4.16797C3.50493 4.16699 2.86904 4.43038 2.4002 4.89923C1.93136 5.36807 1.66797 6.00395 1.66797 6.66699V7.50033H18.3346V6.66699C18.3346 6.00395 18.0712 5.36807 17.6024 4.89923C17.1336 4.43038 16.4977 4.16699 15.8346 4.16699Z",
    fill: "white"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.66797 15.8337C1.66797 16.4967 1.93136 17.1326 2.4002 17.6014C2.86904 18.0703 3.50493 18.3337 4.16797 18.3337H15.8346C16.4977 18.3337 17.1336 18.0703 17.6024 17.6014C18.0712 17.1326 18.3346 16.4967 18.3346 15.8337V9.16699H1.66797V15.8337Z",
    fill: "white"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-export mr-2 export-icon" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "mr-2",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  width: "20px",
  height: "20px",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M20,20V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V20a2,2,0,0,0,2,2H18A2,2,0,0,0,20,20ZM8,15a1,1,0,1,1,1-1A1,1,0,0,1,8,15Zm0-4a1,1,0,1,1,1-1A1,1,0,0,1,8,11Zm4,8a1,1,0,1,1,1-1A1,1,0,0,1,12,19Zm0-4a1,1,0,1,1,1-1A1,1,0,0,1,12,15Zm0-4a1,1,0,1,1,1-1A1,1,0,0,1,12,11Zm4,4a1,1,0,1,1,1-1A1,1,0,0,1,16,15Zm0-4a1,1,0,1,1,1-1A1,1,0,0,1,16,11Zm0-4H8A1,1,0,0,1,8,5h8a1,1,0,0,1,0,2Z" })
], -1))
const _hoisted_6 = { class: "border rounded-lg bg-white p-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm mb-3 text-gray-400" }, "Выберите города для расчёта маршрута", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold mb-2" }, "Город отправления", -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm mb-5 text-gray-400" }, "Если груз идёт через промежуточные города", -1))
const _hoisted_11 = { class: "font-semibold" }
const _hoisted_12 = { class: "flex items-center gap-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_14 = { class: "flex items-center justify-center mt-3" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold mb-2 mt-5" }, "Город назначения", -1))
const _hoisted_17 = {
  key: 0,
  class: "border rounded-lg bg-white p-3 mt-3"
}
const _hoisted_18 = { class: "flex items-center justify-between mb-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-600 font-semibold" }, "РЕЗУЛЬТАТЫ РАСЧЁТА", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_21 = { class: "border rounded p-3 mb-3" }
const _hoisted_22 = { class: "font-semibold border-b pb-3 mb-3" }
const _hoisted_23 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-600" }, "Накладных", -1))
const _hoisted_25 = { class: "font-semibold mt-2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-600" }, "Вес", -1))
const _hoisted_27 = { class: "font-semibold mt-2" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-600" }, "Объём", -1))
const _hoisted_29 = { class: "font-semibold mt-2" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm mb-3 font-semibold" }, "Туда вошли следующие направления:", -1))
const _hoisted_31 = { class: "font-semibold mb-3 flex items-center justify-between" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_33 = { class: "flex items-center" }
const _hoisted_34 = { class: "flex items-center mr-3" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-600" }, "Накладных:", -1))
const _hoisted_36 = { class: "font-semibold ml-2" }
const _hoisted_37 = { class: "flex items-center mr-3" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-600" }, "Вес:", -1))
const _hoisted_39 = { class: "font-semibold ml-2" }
const _hoisted_40 = { class: "flex items-center mr-3" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-600" }, "Вес:", -1))
const _hoisted_42 = { class: "font-semibold ml-2" }
const _hoisted_43 = { class: "flex items-center mt-3" }
const _hoisted_44 = { class: "WorkplaceItemsFilters__grid-2" }
const _hoisted_45 = { class: "WorkplaceItemsFilters__actions" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_filters_icon = _resolveComponent("filters-icon")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_modal = _resolveComponent("new-modal")!
  const _component_new_checkbox = _resolveComponent("new-checkbox")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_checkbox = _resolveComponent("checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_page_title, { title: "Рабочее окно логиста" }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, { to: "/tms/graph" }, {
          default: _withCtx(() => [
            _createVNode(_component_new_button, { type: "button" }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createTextVNode(" График отправок ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_new_button, {
          class: "NewButton--outline",
          onClick: _ctx.toggleExport
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" Экспорт ")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_new_button, {
          class: "NewButton--outline",
          onClick: _ctx.toggleCalculator
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createTextVNode(" Калькулятор ")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_new_button, {
          class: "NewButton--outline",
          onClick: _ctx.toggle
        }, {
          default: _withCtx(() => [
            _createVNode(_component_filters_icon, { class: "mr-2" }),
            _createTextVNode(" Фильтр ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    (_ctx.export_state.is_open)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 0,
          title: "Экспорт",
          scrollable: "",
          loading: _ctx.export_state.is_loading,
          "max-content": "",
          overflow: "",
          onCancel: _ctx.toggleExport,
          onSubmit: _ctx.exportByCity
        }, {
          default: _withCtx(() => [
            _createVNode(_component_new_select, {
              "can-deselect": "",
              placeholder: "Выберите город",
              value: _ctx.export_state.cityName,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.export_state.cityName) = $event)),
              disabled: _ctx.export_state.is_loading,
              options: _ctx.data_state.cities.list,
              loading: _ctx.data_state.cities.is_loading,
              failed: _ctx.data_state.cities.is_failed,
              "is-invalid": !_ctx.export_state.cityName,
              "error-text": "При получении списка городов произошла ошибка",
              "search-without-refresh": "",
              "select-by": "name",
              onRefresh: _ctx.loadCities
            }, null, 8, ["value", "disabled", "options", "loading", "failed", "is-invalid", "onRefresh"])
          ]),
          _: 1
        }, 8, ["loading", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.calculator_state.is_open)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 1,
          title: "Калькулятор остатков",
          scrollable: "",
          loading: _ctx.calculator_state.is_loading,
          overflow: "",
          "max-content": "",
          "is-grey": "",
          "confirm-button-text": _ctx.getCalcConfirmBtnText,
          "confirm-disabled": _ctx.isCalcDisabled,
          onCancel: _ctx.toggleCalculator,
          onSubmit: _ctx.manageCalc
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _hoisted_8,
              _createVNode(_component_new_select, {
                "can-deselect": "",
                placeholder: "Выберите город",
                value: _ctx.calculator_state.fromCityId,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.calculator_state.fromCityId) = $event)),
                disabled: _ctx.calculator_state.is_loading,
                options: _ctx.data_state.cities.list,
                loading: _ctx.data_state.cities.is_loading,
                failed: _ctx.data_state.cities.is_failed,
                "is-invalid": _ctx.validation$.fromCityId.$error,
                "validation-errors": _ctx.validation$.fromCityId.$errors,
                "error-text": "При получении списка городов произошла ошибка",
                "search-without-refresh": "",
                onRefresh: _ctx.loadCities
              }, null, 8, ["value", "disabled", "options", "loading", "failed", "is-invalid", "validation-errors", "onRefresh"]),
              _createVNode(_component_new_checkbox, {
                class: "checkbox--blue mt-5",
                value: _ctx.calculator_state.isTransit,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.calculator_state.isTransit) = $event)),
                label: "Транзитный рейс",
                disabled: _ctx.calculator_state.is_loading,
                onChange: _ctx.onCheckboxChange
              }, null, 8, ["value", "disabled", "onChange"]),
              (_ctx.calculator_state.isTransit)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _hoisted_10,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calculator_state.transitCityIds, (city, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `transit-city-${i}`,
                        class: "grid grid-cols-1 mb-3"
                      }, [
                        _createElementVNode("div", _hoisted_11, "Транзитный город " + _toDisplayString(i + 1), 1),
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_new_select, {
                            "can-deselect": "",
                            class: "w-full",
                            value: _ctx.calculator_state.transitCityIds[i],
                            "onUpdate:value": ($event: any) => ((_ctx.calculator_state.transitCityIds[i]) = $event),
                            placeholder: "Выберите из списка",
                            loading: _ctx.data_state.cities.is_loading,
                            disabled: _ctx.data_state.cities.is_loading,
                            failed: _ctx.data_state.cities.is_failed,
                            options: _ctx.data_state.cities.list,
                            "is-invalid": !_ctx.calculator_state.transitCityIds[i],
                            "error-text": "При получении списка городов произошла ошибка",
                            onRefresh: _ctx.loadCities
                          }, null, 8, ["value", "onUpdate:value", "loading", "disabled", "failed", "options", "is-invalid", "onRefresh"]),
                          _createVNode(_component_new_button, {
                            class: "NewButton--red",
                            style: { width: 'fit-content' },
                            onClick: ($event: any) => (_ctx.deleteTransitCity(i))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_13
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_new_button, {
                        class: "NewButton--search",
                        style: { width: 'fit-content' },
                        onClick: _ctx.addTransitCity
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15,
                          _createTextVNode(" Добавить город транзит ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_16,
              _createVNode(_component_new_select, {
                "can-deselect": "",
                placeholder: "Выберите город",
                value: _ctx.calculator_state.toCityId,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.calculator_state.toCityId) = $event)),
                disabled: _ctx.calculator_state.is_loading,
                options: _ctx.data_state.cities.list,
                loading: _ctx.data_state.cities.is_loading,
                failed: _ctx.data_state.cities.is_failed,
                "is-invalid": _ctx.validation$.toCityId.$error,
                "validation-errors": _ctx.validation$.toCityId.$errors,
                "error-text": "При получении списка городов произошла ошибка",
                "search-without-refresh": "",
                onRefresh: _ctx.loadCities
              }, null, 8, ["value", "disabled", "options", "loading", "failed", "is-invalid", "validation-errors", "onRefresh"])
            ]),
            (_ctx.calculator_state.response)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createVNode(_component_new_button, {
                      type: "button",
                      class: "NewButton--reset",
                      disabled: _ctx.calculator_state.is_loading,
                      loading: _ctx.calculator_state.is_loading,
                      onClick: _ctx.resetCalculator
                    }, {
                      default: _withCtx(() => [
                        _hoisted_20,
                        _createTextVNode(" Сбросить ")
                      ]),
                      _: 1
                    }, 8, ["disabled", "loading", "onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.getCityName(_ctx.calculator_state.fromCityId)) + " - " + _toDisplayString(_ctx.getCityName(_ctx.calculator_state.toCityId)), 1),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", null, [
                        _hoisted_24,
                        _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.calculator_state.response.totalInvoices), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_26,
                        _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.calculator_state.response.totalWeight) + " кг ", 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_28,
                        _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.calculator_state.response.totalVolume) + " м³ ", 1)
                      ])
                    ])
                  ]),
                  _hoisted_30,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calculator_state.response.directions, (direction, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `direction-${idx}`,
                      class: "border rounded p-3 mb-3"
                    }, [
                      _createElementVNode("div", _hoisted_31, [
                        _createTextVNode(_toDisplayString(direction.directionName) + " ", 1),
                        _createVNode(_component_new_button, {
                          type: "button",
                          class: "NewButton--reset",
                          disabled: _ctx.calculator_state.is_loading,
                          loading: _ctx.calculator_state.is_loading,
                          onClick: ($event: any) => (_ctx.deleteDirection(idx))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_32
                          ]),
                          _: 2
                        }, 1032, ["disabled", "loading", "onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _hoisted_35,
                          _createElementVNode("span", _hoisted_36, _toDisplayString(direction.invoiceCount), 1)
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _hoisted_38,
                          _createElementVNode("span", _hoisted_39, _toDisplayString(direction.totalWeight) + " кг ", 1)
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _hoisted_41,
                          _createElementVNode("span", _hoisted_42, _toDisplayString(direction.totalVolume) + " м³ ", 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _createVNode(_component_cheap, { class: "small mr-3 primary" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Самое раннее ГО: " + _toDisplayString(direction.earliestAwaitShipmentDate), 1)
                          ]),
                          _: 2
                        }, 1024),
                        (direction.hasOversizedCargo)
                          ? (_openBlock(), _createBlock(_component_cheap, {
                              key: 0,
                              class: "small mr-3 red"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Негабаритный груз ")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (direction.hasPriorityClient)
                          ? (_openBlock(), _createBlock(_component_cheap, {
                              key: 1,
                              class: "small mr-3 green"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Приоритетный клиент ")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["loading", "confirm-button-text", "confirm-disabled", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("form", {
      class: "WorkplaceItemsFilters",
      onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_44, [
          _createVNode(_component_the_select, {
            placeholder: "Тип",
            value: _ctx.filters.type,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.type) = $event)),
            disabled: _ctx.loading,
            options: _ctx.TYPE_OPTIONS,
            loading: _ctx.loading,
            multiselect: "",
            "can-deselect": "",
            "select-by": "value"
          }, null, 8, ["value", "disabled", "options", "loading"]),
          _createVNode(_component_the_select, {
            placeholder: "Логист",
            disabled: _ctx.loading,
            loading: _ctx.data_state.logists.is_loading,
            failed: _ctx.data_state.logists.is_failed,
            "infinite-scroll": "",
            "error-text": "При получении списка логистов произошла ошибка",
            options: _ctx.data_state.logists.list,
            value: _ctx.filters.logistIds,
            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.logistIds) = $event)),
            multiselect: "",
            "can-deselect": "",
            onRefresh: _ctx.loadLogists,
            onLoadmore: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadMoreLogists(_ctx.data_state.logists.pagination.current_page + 1))),
            onSearch: _ctx.searchLogists,
            onOptionBySearch: _ctx.unshiftFindedLogist
          }, null, 8, ["disabled", "loading", "failed", "options", "value", "onRefresh", "onSearch", "onOptionBySearch"]),
          _createVNode(_component_checkbox, {
            label: "Опаздывающие рейсы",
            value: _ctx.filters.isDelayed,
            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.isDelayed) = $event)),
            "return-integer": ""
          }, null, 8, ["value"]),
          _createVNode(_component_checkbox, {
            label: "Проект",
            value: _ctx.filters.isProject,
            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters.isProject) = $event)),
            "return-integer": ""
          }, null, 8, ["value"])
        ])
      ]),
      _createElementVNode("div", _hoisted_45, [
        _createVNode(_component_new_button, {
          type: "button",
          disabled: _ctx.loading,
          class: "NewButton--reset mr-3",
          onClick: _ctx.onReset
        }, {
          default: _withCtx(() => [
            _hoisted_46,
            _createTextVNode(" Сбросить ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_new_button, {
          type: "submit",
          disabled: _ctx.loading,
          class: "NewButton--search"
        }, {
          default: _withCtx(() => [
            _hoisted_47,
            _createTextVNode(" Поиск ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ], 544), [
      [_vShow, _ctx.state.is_open]
    ])
  ], 64))
}